<template>
  <div class="pagination">
    <el-pagination
      small
      :page-size="pageSize"
      :current-page.sync="current"
      layout="prev, pager, next"
      :hide-on-single-page="true"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
  /*
   pagination component based on element ui pagination
  */
export default {
  name: "Pagination",
  props: {
    feeds: {
      type: Array,
      required: true
    },
    pageSize: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    }
  },
  computed: {
    current: {
      get () {
        return this.currentPage;
      },
      set (value) {
        this.$emit("currentChange", value);
      },
    },
    total() {
      return Object.keys(this.feeds).length;
    }
  }
};
</script>

<style>
.pagination {
  clear: both;
}
</style>
